import CompanyCard from "../../../../../ReusableComponent/CompanyCard"
import GoogleLogo from "../../../../../../assets/images/googlelogo.png"
import MicrosoftLogo from "../../../../../../assets/images/microsoftlogo.png"
import AmazonLogo from "../../../../../../assets/images/amazonlogo.png"
import MetaLogo from "../../../../../../assets/images/metalogo.png"
import AppleLogo from "../../../../../../assets/images/applelogo.png"
import NetflixLogo from "../../../../../../assets/images/netflixlogo.png"  

const CompanySpecificSection = () => {
  const companies = [
    { logo: GoogleLogo, name: "Google", questions: 450, difficulty: "Hard" },
    { logo: MicrosoftLogo, name: "Microsoft", questions: 380, difficulty: "Medium" },
    { logo: AmazonLogo, name: "Amazon", questions: 520, difficulty: "Hard" },
    { logo: MetaLogo, name: "Meta", questions: 340, difficulty: "Hard" },
    { logo: AppleLogo, name: "Apple", questions: 280, difficulty: "Medium" },
    { logo: NetflixLogo, name: "Netflix", questions: 180, difficulty: "Hard" },
  ];

  return (
    <section className="row mx-0 py-5 d-flex justify-content-center">
      <div className="col-md-11 col-12">
        <div className="row mx-0 d-flex justify-content-center align-items-center">
          <div className="col-12 text-center mb-5">
            <h2 className="fw-bold text-light">Company-Specific Preparation</h2>
          </div>
          <div className="row mx-0">
            {companies.map((company, index) => (
              <CompanyCard key={index} {...company} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanySpecificSection;